import ng from 'angular';

@Component('ib-MmB-gastronomic-proposal-module', 'ibPreSelectionMenuOptions', {
    bindings: {
    },
    controller: PreSelectionMenuOptionsComponent,
    controllerAs: 'preSelectionMenuOptionsCtrl',
    templateUrl: ['MmBAppConstants', function (MmBAppConstants) {
        return MmBAppConstants.templatesRoute + 'ib-pre-selection-menu-options-view.html';
    }],
},
    ['$window'], [])
class PreSelectionMenuOptionsComponent implements ng.IController {

    indexPassengerTabs = 0;
    indexOtherPassengerTabs = 0;
    otherTabSelected = false;
    model: any = {
        isMobile: false,
        allPassengers: [
            {
                name: "Rodrigo Lopez Hurtado",
                status: "Seleccionar durante el vuelo",
                selected: true,
            },
            {
                name: "Luis Antonio Perez Ruiz",
                status: "Menú estandar",
                selected: false,
            },
            {
                name: "Josefina Hurgada",
                status: "Seleccionar durante el vuelo",
                selected: true,
            },
            {
                name: "Lucía Hurgada De La Villa",
                status: "Menú de comidas especiales",
                selected: false,
            },
        ],
        passengerTabs: [],
        otherPassengerTabs: []
    }

    constructor(private $window: ng.IWindowService) { }

    activate = (): any => {
        this.updateIsMobile();
        this.updatePassengerModel();
        this.setEvents();
        ng.element(this.$window).on('resize', () => {
            this.updatePassengerModel();
            this.updateIsMobile();
        });
    };

    setEvents = () => {
        document.querySelectorAll('.radio_expandable').forEach((check: HTMLInputElement) =>{
            check.onchange = () =>{this.onRadioChange(check.id, check.getAttribute('data-expandable'))};
        })
        document.querySelectorAll('.ib-radio__expendable_bind').forEach((check: HTMLInputElement) =>{
            check.onchange = () =>{this.closeAllExpandable(check.id)};
        })
    }

    closeAllExpandable = (excemption) => {
        document.querySelectorAll('.ib-radio__expendable_bind').forEach((check: HTMLInputElement) => {
            if(check.id === excemption) return;
            check.checked = false;
        })
    }

    onRadioChange = (radio, check) => {
        let checkInput = document.getElementById(check) as HTMLInputElement;
        let radioInput = document.getElementById(radio) as HTMLInputElement;
        this.closeAllExpandable('');
        if(check){
            checkInput.checked = radioInput.checked
        }
    };

    selectPassengerTab($index: number) {
        this.indexPassengerTabs = $index;
        this.otherTabSelected = false;
    }

    selectOtherPassengerTab($index: number) {
        this.indexPassengerTabs = 2;
        this.otherTabSelected = true;
        this.indexOtherPassengerTabs = $index;
    }

    private updateIsMobile() {
        this.model.isMobile = this.$window.innerWidth < 480 ? true : false;
    }

    /**
    * This method init the passenger data model regarding quantity of passengers.
    * If the booking have more than 3 or 2 (in resolution < 768px) segments we show otherPassengerTabs.
    */
    private updatePassengerModel() {
        const width = this.$window.innerWidth;
        if (width >= 768) {
            if (this.arePassengersExtensive()) {
                this.model.passengerTabs = this.model.allPassengers.slice(0, 2);
                this.model.otherPassengerTabs = this.model.allPassengers.slice(2);
            } else {
                this.model.passengerTabs = this.model.allPassengers.slice(0);
            }
        } else {
            if (this.arePassengersExtensiveInMobile()) {
                this.model.passengerTabs = this.model.allPassengers.slice(0, 1);
                this.model.otherPassengerTabs = this.model.allPassengers.slice(1);
            } else {
                this.model.passengerTabs = this.model.allPassengers.slice(0);
            }
        }
    }

    private arePassengersExtensive() {
        return this.model.allPassengers.length > 3;
    }

    private arePassengersExtensiveInMobile() {
        return this.model.allPassengers.length > 2;
    }

    $onInit = this.activate();
}
